import React from "react";
import "./card-rates-especial.scss";
import { navigate } from "gatsby";
interface CardInterfaceDescription {
  datas: any;
  login: any;
  gigyaAccount: any;
  onClose: any;
  setBanderaLog: any;
}
const icon_right = require("../../../assets/images/icons/Icon-right.svg");
const CardRatesEspecial = (props: CardInterfaceDescription) => {
  const { login, gigyaAccount, onClose, setBanderaLog } = props;
  const value = props.datas;
  return (
    <div>
      <div className="m-share-modal__container__cardbody__internal__extra">
        <div className="m-share-modal__container__cardbody__internal__text__extra">
          <h4>{value.tituloBanner}</h4>
        </div>
        <div
          className={`m-share-modal__container__cardbody__internal__button `}
          onClick={() => {
            if (gigyaAccount) {
              navigate(value.redireccionBoton);
              onClose(false);
            } else {
              setBanderaLog(true);
              login();
              onClose(false);
            }
          }}
        >
          {
            value.tituloBoton ?
            (
            <div className="ver-mas  gtmRedDeAmorEscogerasHoyDinamico">
              <p className="gtmRedDeAmorEscogerasHoyDinamico">
                {value.tituloBoton}
              </p>
              <div className="ver-mas-imagen  gtmRedDeAmorEscogerasHoyDinamico">
                <img
                  src={icon_right}
                  alt={"ver-mas icon"}
                  className={"gtmRedDeAmorEscogerasHoyDinamico"}
                />
              </div>
            </div>):null
          }
        </div>
      </div>
    </div>
  );
};
export default CardRatesEspecial;
